import * as t from 'io-ts';

import {makeApiType, RLocalApplicationEntryPointIdRef} from './apiTypes';
import {parseApplicationEntryPointAction} from './applicationEntryPointActionModel';
import {RBaseApplicationEntryPointDirty} from './applicationEntryPointModel';

/*
 * Runtime type.
 */

const RLocalApplicationEntryPointDirty = t.intersection([
  RBaseApplicationEntryPointDirty,
  t.type({
    id: RLocalApplicationEntryPointIdRef,
    createdAt: t.Integer,
    updatedAt: t.Integer,
  }),
]);

/*
 * Type.
 */

export interface LocalApplicationEntryPointModel extends t.TypeOf<typeof RLocalApplicationEntryPointDirty> {}
export const RLocalApplicationEntryPoint = t.clean<LocalApplicationEntryPointModel>(
  RLocalApplicationEntryPointDirty as any,
);
export const RLocalApplicationEntryPoints = t.readonlyArray(RLocalApplicationEntryPoint);

/*
 * IO methods.
 */

export function parseLocalApplicationEntryPoints(src: any): ReadonlyArray<LocalApplicationEntryPointModel> {
  return src.items.map((entryPoint: any) => parseLocalApplicationEntryPoint(entryPoint));
}

export function parseLocalApplicationEntryPoint(src: any): LocalApplicationEntryPointModel {
  return {
    id: src.id,
    type: src.type,
    action: parseApplicationEntryPointAction(src.action),
    createdAt: src.created_at,
    updatedAt: src.updated_at,
  };
}

/*
 * API type.
 */

export const ApiLocalApplicationEntryPoint = makeApiType(
  'localApplicationEntryPoint',
  RLocalApplicationEntryPoint,
  parseLocalApplicationEntryPoint,
);
export const ApiLocalApplicationEntryPoints = makeApiType(
  'localApplicationEntryPoints',
  RLocalApplicationEntryPoints,
  parseLocalApplicationEntryPoints,
);
